<template>
  <div class="the-navbar__user-meta flex items-center">
    <!-- <vs-switch v-model="darkModeModel" />
    <span class="ml-2">Chế độ tối</span> -->
    <!-- <div class="text-right leading-tight hidden sm:block"> -->
      <!-- <p class="font-semibold" style="min-width:80px">{{ userInfo.fullName }}</p> -->
      <!--<small>Available</small>-->
    <!-- </div> -->
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img mb-6">
        <img @error="imgError" v-if="userInfo.img" key="onlineImg" :src="userInfo.img" alt="user-img" width="100" height="100" class="rounded-full shadow-md cursor-pointer block" />
        <img v-else key="onlineImg" :src="userInfo.photoURL" alt="user-img" width="100" height="100" class="rounded-full shadow-md cursor-pointer block" />
        <div class="vx-row mt-2" style="margin:auto;justify-content: center">
          <p class="font-semibold" style="min-width:80px">{{ userInfo.fullName }}</p>
        </div>
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown" style="z-index:9999 !important;top:13.3rem !important;">
        <ul style="min-width: 9rem">

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click="$router.push('/user/user-info').catch(() => {})">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Thông tin</span>
          </li>

          <vs-divider class="m-1" />

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click="openDialog">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Cập nhật ảnh đại diện</span>
          </li>

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Đăng xuất</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
    <vs-popup title="Cập nhật ảnh đại diện" :active.sync ="activePopup">
      <div class="vx-row">
        <div class="vx-col mt-2 w-full">
          <vs-upload
              style="padding-left:11rem"
              id="fileInput"
              label ="Ảnh đính kèm"
              accept="image/jpeg"
              automatic
              @on-success="successUpload"
              @change="onFileChange"
              @on-error="errorMessage"
              v-model="form.image"
              :show-upload-button="showUpload"
              :single-upload="true"
              :limit="1"
              >
          </vs-upload>
        </div>
      </div>
      <div class="vx-row mt-4">
            <div class="vx-col w-full">
              <div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2 border-radius" icon-pack="feather" @click="activePopup = false" icon="icon" type="border">Quay lại
                </vs-button>
                <vs-button class="ml-4 mt-2 border-radius" icon-pack="feather" icon="icon" @click="saveImage"> Cập nhật
                </vs-button>
              </div>
            </div>
          </div>
    </vs-popup>

    <my-upload
        field="img"
        v-model="showUploadImage"
        @crop-success="cropSuccess"
        :width="300"
        :height="300"
        img-format="png"
        :langExt  ="vn"
    >

    </my-upload>
  </div>
</template>

<script>
import myUpload from 'vue-image-crop-upload'
import NoImage from '@/assets/images/portrait/small/user-avatar.png';
export default {
  components:{
    'my-upload':myUpload
  },
  data() {
    return {
      userInfo: {
        img:null,
        fullName:null,
        photoURL:require("@/assets/images/portrait/small/user-avatar.png")
      },
      activePopup:false,
      form:{
        image:null
      },
      isActive:true,
      hasError:false,
      fileInput:null,
      fileData:null,
      showUpload:false,
      data:{},
      config:{
         header:{
          'Content-Type': 'image/png'
        }
      },
      showUploadImage:false,
      vn: {
          hint: 'Chọn ảnh cập nhật',
          loading: 'Đang cập nhật...',
          noSupported: 'Trình duyệt không hỗ trợ',
          primary: 'Cập nhật thành công',
          fail: 'Cập nhật thất bại',
          preview: 'Preview',
          btn: {
              off: 'Hủy',
              close: 'Đóng',
              back: 'Quay lại',
              save: 'Cập nhật'
          },
          error: {
              onlyImg: 'Chỉ được đăng tải định dạng là ảnh',
              outOfSize: 'Ảnh tải lên vượt quá dung lượng cho phép',
              lowestPx: 'Ảnh tải lên dung lượng quá thấp.'
          }
      }
    }
  },
  watch: {
    '$store.state.userInformation'(val) {
      if(!this.userInfo.id) {
        this.userInfo = Object.assign({}, this.$store.state.AppActiveUser, val);
      }
    },
  },
  
  created() {
    this.userInfo = Object.assign({}, this.$store.state.AppActiveUser, JSON.parse(localStorage.getItem('userInfo')));
  },
  computed : {
    darkModeModel: {
      get()    { return this.$store.state.theme == "dark" },
      set(val) {
        let themeMode = val == true ? 'dark' : 'light';
        localStorage.setItem('themeMode', themeMode);
        this.$store.dispatch('updateTheme', themeMode);
      }
    }

  },
  methods: {
    cropSuccess: function(e, fileInput){
      this.fileData = e;
      this.saveImage();
    },

    imgError(image) {
      image.target.src = NoImage;
    },

    logout() {
      if (localStorage.getItem("deviceToken")) {
        this.$business.post('/notification/unsubscribe', {tokens: [localStorage.getItem("deviceToken")]}).then(() => {
          this.$vs.loading.close();
        }).catch(() => {
          this.$vs.loading.close();
        }).finally(()=>{
          localStorage.removeItem("access_token");
          location.reload();
        });
      } else {
        localStorage.removeItem("access_token");
        location.reload();
      }
    },
    openDialog: function(){
      this.showUploadImage = true;
      // this.activePopup = true;
    },
    onFileChange: function(e, fileInput){
      if(fileInput){
        this.getBase64(fileInput[0]).then((rs) => {
        this.fileData = rs;
      })
      }
    },
    removeElementsByClass(classname){
      let elements = document.getElementsByClassName(classname);
      while(elements.length > 0){
        elements[0].parentNode.removeChild(elements[0]);
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
          if ((encoded.length % 4) > 0) {
            encoded += '='.repeat(4 - (encoded.length % 4));
          }
          resolve(encoded);
        };
        reader.onerror = error => reject(error);
      });
    },
    saveImage: function(){
      if(!this.fileData){
        return this.$vs.notify({
          text:'Bạn chưa chọn ảnh đại diện',
          icon:'icon-alert',
          iconPack:'feather',
          color:'primary'
        })
      }
      this.$vs.loading();
      const data = localStorage.getItem('userInfo');
      const info = JSON.parse(data);
      const base64 = this.fileData;
      const payload ={
        userId:info.id,
        image:base64
      }
      this.$oauth.post(`/user/upload-image`,payload).then((res) =>{
        const response = res.data;
        this.userInfo.img = response.domain;
        this.$vs.loading.close();
        this.activePopup = false;
        location.reload();
      })
      .catch((err)=>{
        this.activePopup = false;
        this.$vs.loading.close();
        return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
      })
    },
    successUpload: function(){
      this.$vs.notify({
        color:'primary',
        title:'Upload success',
        text:"Upload Image suc"
      })
    },
    errorMessage: function(){
      if ( this.fileData) {
         document.getElementsByClassName("con-input-upload")[0].classList.add("con-input-upload-success")
         return 1;
      }
      document.getElementsByClassName("con-input-upload")[0].classList.remove("con-input-upload-success")
    }

  },
  async created(){
    const data = localStorage.getItem('userInfo');
    const info = JSON.parse(data);
    if(info.img){
      this.userInfo.img = info.img;
      this.userInfo.fullName = info.fullName;
    }
  }
}
</script>
<style>
.border-radius {
  border-radius: 20px;
  height: 30px;
}
.con-input-upload.disabled-upload{
  display: none !important;
}
.con-input-upload-success{
  display: none;
}
.parent-dropdown{
  margin:auto
}
.view-upload{
  display: none;
}
.vicp-operate a{
  color: white !important;
  background-color: #277df6 !important;
  border-radius: 20px !important;
}
</style>
